import { requests } from '../../api/services';
import {
    COMPANY_EDIT_TOKENS,
    LIST_DISCOVERY_OVERVIEW,
    LIST_DISCOVERY_PROFILE,
    LIST_DISCOVERY_SEARCH,
} from '../../utils/Endpoints';
import { BaseModel } from '../../model/shared/BaseModel';
import { DiscoverySearchLogs } from '../../model/discovery/DiscoverySearchLogs';
import { DiscoveryOverview } from '../../model/discovery/DiscoveryOverview';

export const DiscoveryService = {
    getDiscoverySearchLogs: (params?: any): Promise<BaseModel<DiscoverySearchLogs>> =>
        requests.get(`${LIST_DISCOVERY_SEARCH}`, params),
    getDiscoveryProfileLogs: (params?: any): Promise<BaseModel<DiscoverySearchLogs>> =>
        requests.get(`${LIST_DISCOVERY_PROFILE}`, params),
    getDiscoveryOverview: (params?: any): Promise<BaseModel<DiscoveryOverview>> =>
        requests.get(`${LIST_DISCOVERY_OVERVIEW}`, params),
    editCompanyDiscoveryTokens: (id?: number, body?: any) => requests.put(`${COMPANY_EDIT_TOKENS}/${id}`, body),
};
